module.exports = __webpack_public_path__ + "static/media/AU.ef39247d.svg";